var camera, scene, renderer;
 
init();
animate(); 

function init() {
  clock = new THREE.Clock();

  renderer = new THREE.WebGLRenderer();
  renderer.setSize( window.innerWidth, jQuery('#footerContent').height() );
  // renderer.setClearColor( 0x9b1b1b );

  scene = new THREE.Scene();
 
  camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 1, 10000 );
  camera.position.z = 1000;
  scene.add( camera );
 
  textGeo = new THREE.PlaneGeometry(100, 60);
  textTexture = THREE.ImageUtils.loadTexture('images/appacus-8b8fe58319.png');
  textTexture.minFilter = THREE.NearestFilter;
  textMaterial = new THREE.MeshLambertMaterial({color: 0xdadada, opacity: .7, map: textTexture, transparent: true, blending: THREE.AdditiveBlending})
  text = new THREE.Mesh(textGeo,textMaterial);
  text.position.z = 800;
  text.position.y = -130;
  scene.add(text);

  light = new THREE.DirectionalLight(0xffffff,0.8);
  light.position.set(-1,0,1);
  scene.add(light);
 
  smokeTexture = THREE.ImageUtils.loadTexture('images/smoke-97be34bea6.png');
  smokeTexture.minFilter = THREE.NearestFilter;
  smokeMaterial = new THREE.MeshLambertMaterial({color: 0xa8a8a8, map: smokeTexture, transparent: true});
  smokeGeo = new THREE.PlaneGeometry(250,250);
  smokeParticles = [];


  for (p = 0; p < 150; p++) {
    var particle = new THREE.Mesh(smokeGeo,smokeMaterial);
    particle.position.set(Math.random()*500-250,Math.random()*500-250,Math.random()*1000-100);
    particle.rotation.z = Math.random() * 360;
    scene.add(particle);
    smokeParticles.push(particle);
  }
 
  document.getElementById('smoker').appendChild( renderer.domElement );
 
}
 
function animate() {
  delta = clock.getDelta();
  requestAnimationFrame( animate );
  if (jQuery('#smoker').inView()) {
    evolveSmoke();
    render();
  }
}
 
function evolveSmoke() {
  var sp = smokeParticles.length;
  while(sp--) {
    smokeParticles[sp].rotation.z += (delta * 0.2);
  }
}

function render() {
  renderer.render( scene, camera );
}

function onWindowResize(){
  var height = jQuery('#footerContent').height();
  camera.aspect = window.innerWidth / height;
  camera.updateProjectionMatrix();
  renderer.setSize( window.innerWidth, height );
}

window.addEventListener( 'resize', onWindowResize, false );
setTimeout(onWindowResize, 1000);
